import type { AnalyticsEvent, TrackEvent } from '../types/analytics';

const noopTrackEvent: TrackEvent = () => {};

export function createTrackEvent(trackEvent?: TrackEvent): TrackEvent {
  if (typeof trackEvent !== 'function') {
    return noopTrackEvent;
  }
  return (event: AnalyticsEvent) => {
    try {
      trackEvent(event);
    } catch (trackError) {
      console.log('analytics trackEvent error => ', trackError);
    }
  };
}
